export default (host) =>
  (id, width, heigth, filename = 'file', extension = 'jpg') =>
    `${process.env.REACT_APP_CDN_HOST}/files/images/${id}/fit/${width}x${heigth}/${filename}.${extension}`
